exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comming-soon[data-v-6768afc8]{display:none}.width-100[data-v-6768afc8]{width:100%}.has-text-transform-none[data-v-6768afc8]{text-transform:none!important}", ""]);

// exports
